import { render, staticRenderFns } from "./SectionToggle.vue?vue&type=template&id=c9353d52&scoped=true&"
import script from "./SectionToggle.vue?vue&type=script&lang=js&"
export * from "./SectionToggle.vue?vue&type=script&lang=js&"
import style0 from "./SectionToggle.vue?vue&type=style&index=0&id=c9353d52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9353d52",
  null
  
)

export default component.exports